import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';
import { LoginForm, useInvitation } from '@zapier/authentication';
import { useSize } from '@zapier/identity-utils';

import {
  AuthLayout,
  CompaniesIntroPromo,
  InvitationError,
  InvitationTitle,
} from '@zapier/auth-pages/src/components/global';
import { paramToBoolean } from '@zapier/auth-pages/src/utils';
import { useIsWorkflowAPI } from '@zapier/auth-pages/src/utils/useIsWorkflowAPI';
import { useIsClaudeMCPReferrer } from '@zapier/auth-pages/src/utils/isClaudeMCPReferrer';
import { WorkflowAPIHeader } from '../../global/WorkflowAPIHeader';
import { ClaudePromo } from './ClaudePromo';

export function LoginPage() {
  const router = useRouter();
  const size = useSize();

  const forceLoginDisplayForm = paramToBoolean(
    router.query.forceLoginDisplayForm
  );
  const invitationCode = router.query.invitation as string | undefined;
  const next = router.query.next as string | undefined;
  const isReauth = paramToBoolean(router.query.reauth);

  const invitation = useInvitation(invitationCode);
  const isWorkflowAPI = useIsWorkflowAPI();
  const isClaudeReferrer = useIsClaudeMCPReferrer();
  const t = useTranslations('login-page');

  if (!invitation.isValid) {
    return <InvitationError error={invitation?.error} url={router.asPath} />;
  }

  const showTitleOnRight =
    !isReauth && !invitation?.invitation && !isWorkflowAPI;
  const title = isReauth ? (
    t('reauth-title')
  ) : invitation?.invitation ? (
    <InvitationTitle invitation={invitation.invitation} />
  ) : (
    t('title')
  );

  const showPromo = !isReauth && size !== 'small' && !isWorkflowAPI;

  return (
    <AuthLayout
      promo={isClaudeReferrer ? <ClaudePromo /> : <CompaniesIntroPromo />}
      showPromo={showPromo}
      title={title}
      titlePosition={showTitleOnRight ? 'right' : 'center'}
      header={isWorkflowAPI ? <WorkflowAPIHeader /> : null}
      align={showPromo && showTitleOnRight ? 'start' : 'center'}
    >
      <LoginForm
        enableEmailAutoFocus={true}
        forceLoginDisplayForm={forceLoginDisplayForm}
        googleCaptchaSiteKey={
          process.env.NEXT_PUBLIC_GOOGLE_CAPTCHA_SITE_KEY || ''
        }
        invitation={invitation?.isValid ? invitation.invitation : null}
        next={next}
        queryParams={router.query}
        routeTo={router.push}
        showSignupLink={!isReauth}
      />
    </AuthLayout>
  );
}
